// extracted by mini-css-extract-plugin
export var cardContainer = "_o4-0";
export var cardHeader = "_o4-2";
export var collapsedState = "_o4-3";
export var dragHandle = "_o4-5";
export var dragHandleIcon = "_o4-6";
export var dragging = "_o4-1";
export var titleArea = "_o4-4";